import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import classNames from "classnames";
import Button from "material-ui/Button";
import { FormControl } from "material-ui/Form";
import MenuItem from "material-ui/Menu/MenuItem";
import Select from "material-ui/Select";
import Typography from "material-ui/Typography";
import Chip from "material-ui/Chip";
import OneDirectionSync from "../../../../Icons/OneDirectionSync";
import ArrowToolTip from "../../../../common/ArrowToolTip";
import {
  salesforceTimelineStatusExportMappingFormProps,
  SalesforceTimelineStatusExportObjectType,
} from "../../../../../constants/ComponentTypes";

const styles = () => ({
  table: {
    border: "1px solid #E7E9EB",
    width: "100%",
  },

  tableHeader: {
    background: "#F4F6F9",
    fontSize: "13px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
  },

  tableRow: {
    borderTop: "1px solid #E7E9EB",
    fontSize: "15px",
    display: "flex",
    alignItems: "center",
  },

  headerCell: {
    padding: "16px 25px",
    boxSizing: "border-box",
  },

  tableCell: {
    boxSizing: "border-box",
    height: "100%",
    position: "relative",
  },

  paddingBox: {
    padding: "27px 25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "auto",
    boxSizing: "border-box",
    height: "95px",
  },

  tableCellCol1: {
    fontWeight: "bold",
  },

  col1: {
    width: "30%",
  },

  col2: {
    width: "30%",
    borderLeft: "1px solid #E7E9EB",
    borderRight: "1px solid #E7E9EB",
  },

  col3: {
    width: "40%",
  },

  syncBtn: {
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    background: "#FFFFFF",
    position: "absolute",
    top: "50%",
    right: 0,
    transform: "translate(50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    minWidth: "unset",
    minHeight: "unset",
    boxSizing: "border-box",
    padding: 0,
    zIndex: 1,
    "&:hover": {
      background: "#FFFFFF",
      cursor: "auto",
    },
  },

  chipRootGrey: {
    margin: "3px 10px 3px 0",
    float: "left",
    backgroundColor: "#F4F6F9",
    border: "#E7E9EB solid 1px",
    color: "#181819",
    height: "37px",
    borderRadius: "2px",
  },

  chipLabelGrey: {
    padding: "8px",
    fontSize: "13px",
    fontWeight: "bold",
  },

  formControl: {
    width: "100%",
  },
});

/**
 * タイムラインのマッピングテーブル
 */
class TimelineStatusMappingTable extends React.Component {
  state = {
    salesforceObjects: Object.values(SalesforceTimelineStatusExportObjectType),
  };

  handleSelectObject = (key, value) => {
    let mapping = this.props.mapping.set(key, { sobject_name: value });
    this.props.updateMapping(mapping);
  };

  handleSelectField = (key, sobject_name, value) => {
    let v = this.props.mapping.get(key);
    if (v && typeof v === "object") {
      v["field"] = value;
    } else {
      v = { sobject_name: sobject_name, field: value };
    }

    let mapping = this.props.mapping.set(key, v);
    this.props.updateMapping(mapping);
  };

  renderKlItem = (klItem) => {
    const { classes } = this.props;

    return (
      <div
        className={classNames(
          classes.tableCell,
          classes.col1,
          classes.tableCellCol1
        )}
      >
        <div className={classes.paddingBox}>{klItem.value}</div>
        <ArrowToolTip text="Keyman LetterからSalesforceからへの単方向同期">
          <Button className={classes.syncBtn}>
            <OneDirectionSync color="#5a5b62" width={20} height={20} />
          </Button>
        </ArrowToolTip>
      </div>
    )
  }

  renderSalesforceObject = (klItem) => {
    const { classes, enableEdit, mapping, disabled } = this.props;
    let value = mapping.get(klItem.key);
    let sobject_name = 0;
    if (value && value.hasOwnProperty("sobject_name")) {
      sobject_name = value["sobject_name"];
    }

    return (
      <div className={classNames(classes.tableCell, classes.col2)}>
        <div className={classes.paddingBox}>
          {enableEdit ? (
            <FormControl className={classes.formControl}>
              <Select
                value={sobject_name}
                onChange={(e) =>
                  this.handleSelectObject(klItem.key, e.target.value)
                }
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                }}
                disabled={disabled}
                classes={{ select: classes.select }}
                disableUnderline
              >
                <MenuItem key={-1} value={0}>
                  選択してください
                </MenuItem>

                {this.state.salesforceObjects.map((item, i) => (
                  <MenuItem key={i} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            <Typography
              variant="subheading"
              style={sobject_name !== 0 ? {} : { color: "#B1B3B9" }}
            >
              {sobject_name !== 0
                ? SalesforceTimelineStatusExportObjectType[sobject_name.toUpperCase()]
                  .text
                : "対応付けなし"}
            </Typography>
          )}
        </div>
      </div>
    );
  }

  renderSalesforceItem = (klItem) => {
    const { classes, enableEdit, mapping, eventFields } = this.props;
    let value = mapping.get(klItem.key);
    let fields = eventFields;

    let sobject_name = 0,
      field = 0;
    if (value && value.hasOwnProperty("sobject_name")) {
      sobject_name = value["sobject_name"];
    }
    if (value && value.hasOwnProperty("field")) {
      field = value["field"] ? value["field"] : 0;
    }
    let disableFields = sobject_name === 0;

    return (
      <div className={classNames(classes.tableCell, classes.col3)}>
        <div className={classes.paddingBox}>
          {enableEdit ? (
            <FormControl className={classes.formControl}>
              <Select
                value={field}
                onChange={(e) =>
                  this.handleSelectField(
                    klItem.key,
                    sobject_name,
                    e.target.value
                  )
                }
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                }}
                classes={{ select: classes.select }}
                disabled={disableFields}
                disableUnderline
              >
                <MenuItem key={-1} value={0}>
                  選択してください
                </MenuItem>

                {Object.values(fields).map((item, i) => (
                  <MenuItem key={i} value={item.name}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ) : (
            this.renderChip(field, fields)
          )}
        </div>
      </div>
    );
  }

  renderChip = (field, fields) => {
    if (field !== 0 && fields.hasOwnProperty(field)) {
      return (
        <Chip
          label={fields[field].label}
          color="primary"
          classes={{
            root: this.props.classes.chipRootGrey,
            label: this.props.classes.chipLabelGrey,
          }}
        />
      );
    }
  };

  render() {
    const { classes, disabled } = this.props;

    return (
      <div className={classes.table} style={{ pointerEvents: disabled ? "none" : "auto" }}>
        <div className={classes.tableHeader}>
          <div className={classNames(classes.headerCell, classes.col1)} style={{ background: "#FAFAFA" }}>
            Keyman Letter項目
          </div>
          <div className={classNames(classes.headerCell, classes.col2)}>
            Salesforceオブジェクト
          </div>
          <div className={classNames(classes.headerCell, classes.col3)}>
            Salesforce項目
          </div>
        </div>
        {salesforceTimelineStatusExportMappingFormProps.map((klItem, i) => {
          return (
            <div className={classes.tableRow} key={i}>
              {this.renderKlItem(klItem)}
              {this.renderSalesforceObject(klItem)}
              {this.renderSalesforceItem(klItem)}
            </div>
          )
        })}
      </div>
    );
  }
}

TimelineStatusMappingTable.propTypes = {
  classes: PropTypes.object.isRequired,
  mapping: PropTypes.object.isRequired,
  enableEdit: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  updateMapping: PropTypes.func,
  eventFields: PropTypes.object,
};

export default withStyles(styles)(TimelineStatusMappingTable);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceTimelineStatusSetting/parts/TimelineStatusMappingTable.jsx